/** Re-employment register listing domain storage. Per-tab (sessionStorage) search state, kept apart from every other listing's. */
import Storage from '../index';
import StorageKeys from '../keys';

const reEmployment = {
    getSearchState: (lang) => Storage.get(StorageKeys.reEmploymentSearchState(lang), null),
    setSearchState: (lang, state) => Storage.set(StorageKeys.reEmploymentSearchState(lang), state),
};

export default reEmployment;
